export default __webpack_public_path__ + "static/Net_Atlantic-1462aea6b632bf85fd03f55ec9542933.jpg";